module.exports = __webpack_public_path__ + "static/img/img_bg_01.608b7e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_bg_01.jpg
// module id = 148
// module chunks = 1